import React from 'react';
import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import VideoProgressBar from './VideoProgressBar';
import VideoProgressDetails from './VideoProgressDetails';
import TextWithTooltip from 'chameleon/ui-stack/ui/assessments/text-with-tooltip';

const VideoProgressBarPopover = (props) => {
  const { progress, withoutPopover = false } = props;
  const { not_started: notStarted, started, watched } = progress;

  const hasProgress = progress.started + progress.watched > 0;
  const tooltipTargetId = `tooltip-video-progress-performance-popover-${uniqid()}`;
  const popOverContentId = `video-progress-performance-popover-${uniqid()}`;
  const ariaLabel = `Open Video Progress details: Not Started: ${notStarted} , Started: ${started}, Watched: ${watched}`;
  return !hasProgress || withoutPopover ? (
    <VideoProgressBar active={false} progress={progress} />
  ) : (
    <PopOver
      showCloseButton
      className="progress_details_popover popover_underneath"
      size="wide"
      popoverStyles={{ maxWidth: '600px' }}
      accessibility={{
        'aria-label': ariaLabel,
        'aria-describedby': popOverContentId,
      }}
      trigger={
        <TextWithTooltip
          target={hasProgress ? tooltipTargetId : ''}
          ariaLabel={hasProgress ? 'View Student Progress' : ''}
          tooltip={hasProgress ? 'View Student Progress' : ''}
        >
          <VideoProgressBar id={tooltipTargetId} active progress={progress} />
        </TextWithTooltip>
      }
      {...props}
    >
      <VideoProgressDetails
        progress={progress}
        progressDetailsId={popOverContentId}
      />
    </PopOver>
  );
};

VideoProgressBarPopover.displayName = 'VideoProgressBarPopover';
VideoProgressBarPopover.defaultProps = {
  progress: {},
};
VideoProgressBar.propTypes = {
  progress: PropTypes.shape({
    not_started: PropTypes.number,
    started: PropTypes.number,
    watched: PropTypes.number,
    total_students: PropTypes.number,
  }),
};
export default VideoProgressBarPopover;
